import { Close } from "@mui/icons-material";
import { Box, Chip, IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { formatDate } from "src/Utils/DateUtils";
import { dateRangeFilters, numberRangeFilters } from "./FiltersBars";

export enum FILTERS_UI_NAMES_MAPPING {
  vendorName = "Vendor name",
  pan = "PAN",
  grnNumber = "GRN number",
  grnDate = "GRN date",
  invoiceNumber = "Invoice number",
  amountDisbursed = "Payment to be made",
  discountAmount = "Discount amount",
  initiationDate = "Initiation date",
  grnAmount = "GRN amount",
  earlyPaymentStatus = "Early payment status",
  dnAdjusted = "DN adjusted",
  incomeAccruedToSwiggy = "Income accrued to Swiggy",
  entityName = "Organization name",
  cnNumber = "CN number",
  cnStatus = "CN status",
  invoiceAmount = "Invoice amount",
  anchorCnReceived = "Actual CN received (Swiggy)",
  earlyPayDate = "Early pay date",
  vendorCode = "Vendor code",
  nakadCnReceived = "Actual CN received (NAKAD)",
  cnAgeingStatus = "CN ageing status",
  gstin = "GSTIN",
  warehouseName = "Warehouse name",
  city = "City",
  state = "State",
  invoicePostedStatus = "Status of invoice",
  poNumber = "PO no.",
  poDate = "PO date",
  poAmount = "PO amount",
  invoiceAccountDate = "Invoice accounting date",
  tds = "TDS/TCS",
  purchaseReturnAmount = "Purchase return amount",
  brandDiscount = "Brand discount (Promo claims)",
  debitAmount = "Other debit amount",
  adjustments = "Other adjustments",
  netPayableAmount = "Net payable amount",
  otherAdjustmentDate = "Other adjustment date",
  invoiceReconciledStatus = "Invoice status",
  paymentAmount = "Payment amount",
  paymentReferenceNumber = "Payment reference no.",
  outstandingAmount = "Outstanding payment",
  creditPeriod = "Credit period",
  dueDate = "Due date",
  newDueDate = "New due date",
  overDueStatus = "Overdue",
  paymentStatus = "Payment status",
  lastPaymentDate = "Last payment date",
  earlyPayPass = "Early pay pass",
  discountingStatus = "Discounting status",
  cnAgeing = "CN ageing",
  balanceAmountToBePaidOnDueDate = "Balance amount to be paid on due date",
  grossPaymentAmount = "Gross payment amt",
  effectiveCB = "Effective CB",
  startingCB = "Starting CB",
  outstandingAmountNakad = "Outstanding (NAKAD)",
  finalAdjustments = "Adjustments",
  holdOffAmount = "Hold-off amt",
  invoiceAccountingDate = "Invoice accounting date",
}

export default function SingleFilter({ filterName, filteredValues, setColumnFilters, setAppliedFilters }) {
  const isDateRangeFilter = dateRangeFilters.includes(filterName);
  const isNumberRangeFilter = numberRangeFilters.includes(filterName);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if ((event.target as HTMLElement).id !== "close-button") {
      setAnchorEl(event.currentTarget);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontSize: "16px",
            fontWeight: 500,
          }}
        >
          {FILTERS_UI_NAMES_MAPPING[filterName] || filterName}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "#ffffff",
            border: "1px solid #0000003b",
            borderRadius: "4px",
            padding: "2px 6px",
            cursor: "pointer",
            width: "fit-content",
          }}
          onClick={handleMenuOpen}
        >
          {isDateRangeFilter || isNumberRangeFilter ? (
            <Stack direction="row" gap={1}>
              {filteredValues[0] && (
                <Chip
                  size="small"
                  label={
                    <span className="fs_13">
                      <span className="fs_13 fw_900">{isDateRangeFilter ? "Start:" : "Min:"}</span>
                      {isDateRangeFilter ? formatDate(filteredValues[0]) : filteredValues[0]}
                    </span>
                  }
                />
              )}
              {filteredValues[1] && (
                <Chip
                  size="small"
                  label={
                    <span className="fs_13">
                      <span className="fs_13 fw_900">{isDateRangeFilter ? "End:" : "Max:"}</span>{" "}
                      {isDateRangeFilter ? formatDate(filteredValues[1]) : filteredValues[1]}
                    </span>
                  }
                />
              )}
            </Stack>
          ) : (
            <Stack direction="row" gap={1} alignItems={"center"}>
              <Chip
                sx={{
                  ".MuiChip-label": {
                    fontSize: "13px",
                  },
                }}
                size="small"
                label={filteredValues.length > 0 ? (filteredValues[0] === "-" ? "None" : filteredValues[0]) : ""}
              />
              {filteredValues.length > 1 && (
                <Typography
                  variant="body2"
                  sx={{
                    color: "#1976d2",
                    marginRight: "8px",
                  }}
                >
                  +{filteredValues.length - 1}
                </Typography>
              )}
            </Stack>
          )}

          <IconButton
            size="small"
            id="close-button"
            sx={{
              color: "#707070",
            }}
            onClick={(e) => {
              e.stopPropagation();
              setAppliedFilters((prev) => {
                const newFilters = { ...prev };
                newFilters[filterName] = [];
                return newFilters;
              });
              setColumnFilters((prev) => {
                return prev.filter((filter) => filter.id !== filterName);
              });
            }}
          >
            <Close />
          </IconButton>
        </Box>
        {!isDateRangeFilter && (
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              style: {
                minWidth: anchorEl ? anchorEl.clientWidth : "auto",
              },
            }}
          >
            {filteredValues.map((value, index) => (
              <MenuItem key={index} onClick={handleClose}>
                {value === "-" ? "None" : value}
              </MenuItem>
            ))}
          </Menu>
        )}
      </Box>
    </>
  );
}
